<!-- features/partners/page/partner-upsert/partner-upsert.html -->
@if (editingId) {
  <ui-organism-main-nav [mainText]="'partners.form.editTitle' | translate"> </ui-organism-main-nav>
} @else {
  <ui-organism-main-nav [mainText]="'partners.form.createTitle' | translate">
  </ui-organism-main-nav>
}

<ui-atom-spacer />
<ui-atom-text type="medium" [text]="'partners.form.subtitle' | translate"> </ui-atom-text>
<ui-atom-spacer size="spacer-xxl" />

<section class="partner-upsert-form">
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="partner-upsert-form__grid"
    autocomplete="off"
  >
    <!-- Nombre -->
    <div class="partner-upsert-form__field">
      <ui-molecule-input
        textId="name"
        formControlName="name"
        [label]="'partners.form.name.label' | translate"
        [placeholder]="'partners.form.name.placeholder' | translate"
        required="true"
      >
      </ui-molecule-input>
      <div
        class="ui-input-error-container"
        [class.hidden]="!nameControl?.touched || nameControl?.valid"
      >
        @if (nameControl?.hasError('required')) {
          <span>{{ 'partners.form.name.error.required' | translate }}</span>
        }
        @if (nameControl?.hasError('minlength')) {
          <span>{{ 'partners.form.name.error.minLength' | translate }}</span>
        }
        @if (nameControl?.hasError('maxlength')) {
          <span>{{ 'partners.form.name.error.maxLength' | translate }}</span>
        }
      </div>
    </div>

    <!-- Acciones -->
    <div class="partner-upsert-form__actions">
      <ui-atom-button
        type="button"
        rules="main"
        styling="outlined"
        [withShadow]="false"
        [text]="'partners.form.actions.cancel' | translate"
        (click)="cancel()"
      >
      </ui-atom-button>

      <ui-atom-button
        type="button"
        rules="main"
        styling="filled"
        [withShadow]="true"
        [disabled]="isLoading"
        [text]="
          editingId
            ? ('partners.form.actions.save' | translate)
            : ('partners.form.actions.create' | translate)
        "
        (click)="onSubmit()"
      >
      </ui-atom-button>
    </div>
  </form>
</section>
